// triggers graph background animation once scrolled into view
if($('.graph-block').length > 0) {
    var waypoint = new Waypoint({
        element: document.getElementsByClassName('graph-block')[0],
        handler: function(direction) {
            if (direction == "down") {
                var objectEl = document.getElementById("graph-bg"),
                    objectDoc = objectEl.contentDocument,
                    svg = objectDoc.getElementById("eXYfgLwiZ6d1");

                svg.svgatorPlayer.play();

                var objectElPulse = document.getElementById("graph-dots-bg"),
                    objectDocPulse = objectElPulse.contentDocument,
                    svgPulse = objectDocPulse.getElementById("enm1rYJW3Uk1");

                svgPulse.svgatorPlayer.play();

                document.getElementsByClassName('graph-block')[0]
                .classList.add("in-view");
            } else {
                this.destroy();
            }
        },
        offset: '50%'
    });
}
